import React from 'react';
import { ChatMessage as ChatMessageType } from '../../context/ChatbotContext';

interface ChatMessageProps {
  message: ChatMessageType;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const { role, content, timestamp } = message;
  
  // Format timestamp to show only hours and minutes
  const formatTime = (date: Date): string => {
    return new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  };
  
  // Different styling based on message role
  const isBot = role === 'bot';
  const isUser = role === 'user';
  
  if (isBot) {
    return (
      <div className="flex items-start">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white mr-2">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
            />
          </svg>
        </div>
        <div className="max-w-[80%]">
          <div className="bg-white p-3 rounded-lg shadow-sm dark:bg-neutral-800 dark:text-white">
            <div className="whitespace-pre-line">{content}</div>
          </div>
          <div className="text-xs text-gray-500 mt-1 dark:text-gray-400">
            {formatTime(timestamp)}
          </div>
        </div>
      </div>
    );
  }
  
  if (isUser) {
    return (
      <div className="flex items-start justify-end">
        <div className="max-w-[80%]">
          <div className="bg-primary text-white p-3 rounded-lg shadow-sm">
            <div>{content}</div>
          </div>
          <div className="text-xs text-gray-500 mt-1 text-right dark:text-gray-400">
            {formatTime(timestamp)}
          </div>
        </div>
      </div>
    );
  }
  
  // System messages (rarely used, but included for completeness)
  return (
    <div className="flex justify-center">
      <div className="bg-gray-200 text-gray-700 text-sm py-1 px-3 rounded-full dark:bg-neutral-700 dark:text-gray-300">
        {content}
      </div>
    </div>
  );
};

export default ChatMessage;
